import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface SkeletonProps {
  width?: string;
  height?: string;
}
const Skeleton = t0 => {
  const $ = _c(3);
  const {
    width: t1,
    height: t2
  } = t0;
  const width = t1 === undefined ? "100%" : t1;
  const height = t2 === undefined ? "100%" : t2;
  let t3;
  if ($[0] !== height || $[1] !== width) {
    t3 = <div className="bg-gray-100 rounded-md" style={{
      width,
      height
    }} />;
    $[0] = height;
    $[1] = width;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default Skeleton;